var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { Service } from '~/core/service';
var CompanyService = /** @class */ (function (_super) {
    __extends(CompanyService, _super);
    function CompanyService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 创建公司接口
     * @param params
     */
    CompanyService.prototype.createCompany = function (data) {
        return this.netService.send({
            server: managementService.companyController.createCompany,
            data: {
                companyAddress: data.companyAddress,
                companyName: data.companyName,
                companyPhone: data.companyPhone,
                companyStatus: data.companyStatus
            },
            loading: true
        });
    };
    /**
     * 获取所有公司接口
     * @param data 查询条件
     */
    CompanyService.prototype.findAllCompany = function (data) {
        return this.netService.send({
            server: managementService.companyController.findAllCompany,
            data: data
        });
    };
    /**
     * 获取所有公司接口
     * @param params 查询条件
     * @param page 分页参数
     */
    CompanyService.prototype.queryAllCompanyPage = function (params, page) {
        return this.netService.send({
            server: managementService.companyController.queryAllCompanyPage,
            data: {
                companyName: params.companyName
            },
            page: page
        });
    };
    /**
     * 修改公司接口
     * @param params
     */
    CompanyService.prototype.modify = function (data) {
        return this.netService.send({
            server: managementService.companyController.modify,
            data: {
                companyAddress: data.companyAddress,
                companyName: data.companyName,
                companyPhone: data.companyPhone,
                companyStatus: data.companyStatus,
                id: data.id
            },
            loading: true
        });
    };
    __decorate([
        Inject(NetService)
    ], CompanyService.prototype, "netService", void 0);
    return CompanyService;
}(Service));
export { CompanyService };
